export default "__VITE_ASSET__cef9b08b__"